var render = function render(){var _vm=this,_c=_vm._self._c;return (this.$store.state.loading)?_c('div',{staticClass:"text-center spinnerLoader"},[_c('div',{staticClass:"spinner-border m-2",attrs:{"role":"status"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }